import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const AccordionArrowDown: React.FC<Props> = () => {
  return (
    <SVGIcon width="18" height="12" viewBox="0 0 18 12" fill="none">
      <path
        d="M17 2.50094L16.0187 1.51961L9 8.53827L1.98133 1.51961L1 2.50094L8.50933 10.0103L9 10.4796L9.49067 10.0103L17 2.50094Z"
        fill="#212121"
        stroke="#555555"
      />
    </SVGIcon>
  );
};

export default AccordionArrowDown;
